import React from "react";
import ReactMarkdown from "react-markdown";

const MarkdownRenderer = ({ content }) => {
  return (
    <span className="prose prose-lg max-w-none">
      <ReactMarkdown>{content}</ReactMarkdown>
    </span>
  );
};

export {MarkdownRenderer}

